<script>
  export let platform
  export let addBlock

  import { onMount } from 'svelte'
  import { fade } from 'svelte/transition'

  const { store } = platform
  const { config } = platform.storeData

  const pluginRefs = []

  const layoutCategories = platform.components[$store.render.template.custom.ref]?.presets || []

  let selectedCategoryIndex = 0

  let loaded = false

  onMount(async () => {
    for (const category of layoutCategories) {
      for (const layout of category.layouts) {
        for (const plugin of layout.plugins) {
          if (!pluginRefs.includes(plugin.ref)) {
            pluginRefs.push(plugin.ref)
          }
        }
      }
    }
    await platform.api.core.loadComponents([...pluginRefs], { missing: config.components.missing })

    setTimeout(() => {
      loaded = true
    }, 0)
  })

  function selectCategory (index) {
    selectedCategoryIndex = index
  }

  function addContentBlock (block) {
    addBlock({
      layout: block.layout,
      plugins: block.plugins,
    })
  }
</script>

<!-- svelte-ignore a11y-no-static-element-interactions -->
<!-- svelte-ignore a11y-click-events-have-key-events -->

<div class="categories">
  {#each layoutCategories || [] as category, i}
    <div
      class="category-selector"
      class:selected={selectedCategoryIndex === i}
      on:click={() => selectCategory(i)}
    >
      {category.name}
    </div>
  {/each}
</div>

<!-- svelte-ignore a11y-no-static-element-interactions -->
<!-- svelte-ignore a11y-click-events-have-key-events -->

<div class="layouts add-layouts cms-template">
  {#if layoutCategories.length && loaded}
    {@const categoryLayouts = layoutCategories[selectedCategoryIndex].layouts}
    {#each categoryLayouts || [] as block}
      <div class="layout-container" on:click={() => addContentBlock(block)}>
        <div class="layout-container__inner" in:fade={{ duration: 200 }}>
          <div
            style={`
              ${block.layout.fields?.backgroundColour && 'background: ' + block.layout.fields?.backgroundColour};
              ${block.layout.fields?.backgroundImage && 'background-image: url(' + block.layout.fields?.backgroundImage}?size=xl);
              ${block.layout.fields?.fontColour && 'color: ' + block.layout.fields?.fontColour};
            `}
            class={`
              outside layout
              ${block.layout.classNames.join(' ')}
              ${block.layout.fields.classNames?.map(cn => cn.class).join(' ')}
            `}
          >
            {#each block.layout.rows[0] as row}
              <div class={`${row.classNames.join(' ')} row`}>
                {#each block.plugins as plugin}
                  {#if plugin.rowName === row.name}
                    {@const module = platform.components[plugin.ref]}
                    {@const fields = JSON.parse(plugin.fields)}
                    <svelte:component
                      this={module.default}
                      fields={fields}
                    />
                  {/if}
                {/each}
              </div>
            {/each}
          </div>
        </div>
        <!-- <div class="block-name" on:click|stopPropagation>
          <span>{block.name}</span>
        </div> -->
      </div>
    {/each}
  {/if}
</div>

<style lang="scss">.categories {
  display: flex;
  gap: 0.75rem;
  width: 100%;
}

.category-selector {
  text-transform: capitalize;
  padding: 0.5rem;
  text-align: center;
  min-width: 80px;
  text-wrap: nowrap;
  border-radius: 0.25rem;
  background-color: rgb(245, 245, 245);
  transition: 0.3s;
}
.category-selector.selected {
  background-color: rgb(230, 230, 230);
  font-weight: bold;
}
.category-selector:hover {
  cursor: pointer;
  background-color: rgb(235, 235, 235);
}

.layouts {
  max-width: 100%;
  display: grid;
  grid-template-columns: 100%;
  gap: 1rem;
  overflow-x: hidden;
}

.layout-container {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}
.layout-container__inner {
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  position: relative;
  overflow: hidden;
  border: 1px solid rgb(218, 218, 218);
  border-radius: 1rem;
  transition: 0.3s;
}
.layout-container__inner::after {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: transparent;
  z-index: 1;
}
.layout-container__inner:hover {
  transform: translateY(-0.5rem);
  cursor: pointer;
}

.layout {
  width: 100%;
  margin-top: 0px !important;
  margin-bottom: 0px !important;
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
}

:global(.add-layouts) :global(h1), :global(.add-layouts) :global(h2), :global(.add-layouts) :global(h3), :global(.add-layouts) :global(h4) {
  font-size: revert !important;
}

.row {
  max-height: 100%;
}

.block-name {
  width: 100%;
  text-align: center;
  font-weight: bold;
  font-size: 1.1rem;
  display: flex;
  align-items: center;
  justify-content: center;
}

:global(.add-layouts) .outside.single-column .layout-column {
  width: 70%;
}
:global(.add-layouts) .text-left {
  text-align: left;
}
:global(.add-layouts) .text-center {
  text-align: center;
}
:global(.add-layouts) .text-right {
  text-align: right;
}
:global(.add-layouts) .items-start {
  align-items: flex-start;
}
:global(.add-layouts) .items-center {
  align-items: center;
}
:global(.add-layouts) .items-end {
  align-items: flex-end;
}
:global(.add-layouts) .my-0 {
  margin-top: 0px;
  margin-bottom: 0px;
}
:global(.add-layouts) .my-2 {
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
}
:global(.add-layouts) .my-4 {
  margin-top: 1rem;
  margin-bottom: 1rem;
}
:global(.add-layouts) .my-8 {
  margin-top: 2rem;
  margin-bottom: 2rem;
}
:global(.add-layouts) .my-12 {
  margin-top: 3rem;
  margin-bottom: 3rem;
}
:global(.add-layouts) .my-16 {
  margin-top: 4rem;
  margin-bottom: 4rem;
}
:global(.add-layouts) .my-24 {
  margin-top: 6rem;
  margin-bottom: 6rem;
}
:global(.add-layouts) .my-32 {
  margin-top: 8rem;
  margin-bottom: 8rem;
}
@media (max-width: 650px) {
  :global(.add-layouts) .my-8, :global(.add-layouts) .my-12, :global(.add-layouts) .my-16, :global(.add-layouts) .my-24, :global(.add-layouts) .my-32 {
    margin-top: 2rem;
    margin-bottom: 2rem;
  }
}
:global(.add-layouts) .px-0 {
  padding-left: 0px;
  padding-right: 0px;
}
:global(.add-layouts) .px-4 {
  padding-left: 1rem;
  padding-right: 1rem;
}
:global(.add-layouts) .px-8 {
  padding-left: 2rem;
  padding-right: 2rem;
}
:global(.add-layouts) .px-16 {
  padding-left: 4rem;
  padding-right: 4rem;
}
:global(.add-layouts) .px-24 {
  padding-left: 6rem;
  padding-right: 6rem;
}
:global(.add-layouts) .px-32 {
  padding-left: 8rem;
  padding-right: 8rem;
}
@media (max-width: 650px) {
  :global(.add-layouts) .px-8, :global(.add-layouts) .px-16, :global(.add-layouts) .px-24, :global(.add-layouts) .px-32 {
    padding-left: 1rem;
    padding-right: 1rem;
  }
}
:global(.add-layouts) .py-0 {
  padding-top: 0px;
  padding-bottom: 0px;
}
:global(.add-layouts) .py-8 {
  padding-top: 2rem;
  padding-bottom: 2rem;
}
:global(.add-layouts) .py-16 {
  padding-top: 4rem;
  padding-bottom: 4rem;
}
:global(.add-layouts) .py-24 {
  padding-top: 6rem;
  padding-bottom: 6rem;
}
:global(.add-layouts) .py-32 {
  padding-top: 8rem;
  padding-bottom: 8rem;
}
@media (max-width: 650px) {
  :global(.add-layouts) .py-8, :global(.add-layouts) .py-16, :global(.add-layouts) .py-24, :global(.add-layouts) .py-32 {
    padding-top: 1rem;
    padding-bottom: 1rem;
  }
}
:global(.add-layouts) .max-w-full {
  max-width: 100%;
}</style>
<script context="module">export const svelteCompilerVersion = {"major":4,"minor":2,"patch":18};</script>